<template>
  <page-header-wrapper>
    <div class="business-page erp-list-page baidao-list-page warehouse-list-page">
      <section class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="关键字"><a-input v-model="query.keyword" allow-clear placeholder="仓库编码或名称" @pressEnter="applyQuery" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="状态"><a-select v-model="query.status" allow-clear placeholder="全部状态"><a-select-option value="enabled">启用</a-select-option><a-select-option value="disabled">停用</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="24" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="applyQuery">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
          </a-row>
        </a-form>
      </section>

      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>仓库档案</h3><p>维护销售出库、库存台账和期初业务可使用的仓库；仅启用仓库可用于新销售订单。</p></div>
          <div class="erp-toolbar-actions"><span class="record-count erp-record-count">共 {{ filteredWarehouses.length }} 条</span><!-- 暂时只保留一个仓库，先不开放新增
          <a-button type="primary" icon="plus" @click="startAdd">新增仓库</a-button>
          --></div>
        </div>
        <a-table
          :columns="columns"
          :data-source="filteredWarehouses"
          :loading="loading"
          row-key="id"
          bordered
          size="middle"
          :scroll="{ x: 920 }"
          :pagination="{ pageSize: 20, showTotal: total => `共 ${total} 条` }"
          :locale="{ emptyText: '暂无符合条件的仓库' }">
          <template slot="warehouseCode" slot-scope="value, record"><a @click="startView(record)">{{ value }}</a></template>
          <template slot="status" slot-scope="value"><a-tag class="erp-status-tag" :color="value === 'enabled' ? 'green' : 'default'">{{ value === 'enabled' ? '启用' : '停用' }}</a-tag></template>
          <template slot="operation" slot-scope="value, record">
            <a @click="startView(record)">查看</a><a-divider type="vertical" /><a @click="startEdit(record)">编辑</a>
            <!-- 暂时只保留一个仓库，先不开放启停
            <a-divider type="vertical" />
            <a @click="toggleStatus(record)">{{ record.status === 'enabled' ? '停用' : '启用' }}</a>
            -->
          </template>
        </a-table>
      </section>

      <a-drawer
        :visible="drawerVisible"
        :width="drawerWidth"
        :closable="false"
        :body-style="{ padding: 0 }"
        :mask-closable="false"
        class="erp-doc-drawer baidao-drawer-sample warehouse-drawer"
        @close="cancelEdit">
        <div class="erp-drawer-shell">
          <header class="erp-drawer-header">
            <div><button class="erp-back-button" type="button" title="返回仓库列表" aria-label="返回仓库列表" @click="cancelEdit"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看档案' : (draft.id ? '编辑档案' : '新建档案') }}</span><h3>{{ draft.warehouseName || '新建仓库档案' }}</h3></div>
            <div><a-button @click="cancelEdit">取消</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="submit">保存</a-button></div>
          </header>
          <div class="erp-drawer-content">
            <div class="erp-status-strip"><a-tag class="erp-status-tag" :color="draft.status === 'disabled' ? 'default' : 'green'">{{ draft.status === 'disabled' ? '停用' : '启用' }}</a-tag><span>仓库仍有库存或未完成订单时不能停用；存在业务引用时不能修改经营主体。</span></div>
            <section class="erp-form-card">
              <div class="erp-section-title"><span class="erp-section-index">01</span><div><h4>基础信息</h4><p>仓库编码和名称用于销售、库存及期初单据识别</p></div></div>
              <div class="erp-base-grid warehouse-grid">
                <label><span><b class="erp-required">*</b> 仓库编码</span><a-input v-model="draft.warehouseCode" :disabled="readOnly" maxlength="64" placeholder="请输入仓库编码" /></label>
                <label><span><b class="erp-required">*</b> 仓库名称</span><a-input v-model="draft.warehouseName" :disabled="readOnly" maxlength="128" placeholder="请输入仓库名称" /></label>
                <label><span>经营主体 ID</span><a-input-number v-model="draft.operatingSubjectId" :disabled="readOnly || !!draft.id" style="width:100%" /></label>
                <label><span>当前状态</span><a-input :value="draft.status === 'disabled' ? '停用' : '启用'" disabled /></label>
                <label class="wide"><span>备注</span><a-textarea v-model="draft.remark" :disabled="readOnly" :rows="4" maxlength="500" placeholder="请输入仓库用途或管理说明（选填）" /></label>
              </div>
            </section>
          </div>
          <footer class="erp-drawer-footer"><div><a-icon type="info-circle" /> 保存仓库档案不会改变现有库存；启停操作请在列表中单独执行。</div><div><a-button @click="cancelEdit">返回列表</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="submit">保存档案</a-button></div></footer>
        </div>
      </a-drawer>
    </div>
  </page-header-wrapper>
</template>

<script>
import { listWarehouse, saveWarehouse } from '@/api/erp/warehouse'

export default {
  name: 'ErpWarehouse',
  data () {
    return {
      query: { keyword: '', status: undefined },
      appliedQuery: { keyword: '', status: undefined },
      warehouses: [],
loading: false,
saving: false,
editing: false,
drawerVisible: false,
readOnly: false,
viewportWidth: window.innerWidth,
draft: {},
      columns: [
        { title: '仓库编码', dataIndex: 'warehouseCode', width: 190, scopedSlots: { customRender: 'warehouseCode' } },
        { title: '仓库名称', dataIndex: 'warehouseName', width: 240 },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '备注', dataIndex: 'remark' },
        { title: '操作', dataIndex: 'operation', width: 210, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  computed: {
    drawerWidth () { return this.viewportWidth < 900 ? '100%' : '88%' },
    filteredWarehouses () {
      const keyword = (this.appliedQuery.keyword || '').trim().toLowerCase()
      return this.warehouses.filter(row => {
        const matchesKeyword = !keyword || [row.warehouseCode, row.warehouseName].some(value => String(value || '').toLowerCase().includes(keyword))
        const matchesStatus = !this.appliedQuery.status || row.status === this.appliedQuery.status
        return matchesKeyword && matchesStatus
      })
    }
  },
  created () { this.loadData(); window.addEventListener('resize', this.updateViewport) },
  beforeDestroy () { window.removeEventListener('resize', this.updateViewport) },
  methods: {
    updateViewport () { this.viewportWidth = window.innerWidth },
    loadData () {
      this.loading = true
      listWarehouse().then(res => { this.warehouses = res.data || [] }).finally(() => { this.loading = false })
    },
    applyQuery () { this.appliedQuery = { ...this.query } },
    resetQuery () { this.query = { keyword: '', status: undefined }; this.applyQuery() },
    // 暂时只保留一个仓库，先不开放新增
    // startAdd () { this.draft = { warehouseCode: '', warehouseName: '', remark: '', operatingSubjectId: 0, status: 'enabled' }; this.readOnly = false; this.editing = true; this.drawerVisible = true },
    startEdit (record) { this.draft = { ...record }; this.readOnly = false; this.editing = true; this.drawerVisible = true },
    startView (record) { this.draft = { ...record }; this.readOnly = true; this.editing = true; this.drawerVisible = true },
    cancelEdit () { this.editing = false; this.drawerVisible = false; this.readOnly = false; this.draft = {} },
    submit () {
      if (!this.draft.warehouseCode || !this.draft.warehouseName) return this.$message.warning('请填写仓库编码和名称')
      this.saving = true
      saveWarehouse(this.draft).then(() => {
        this.$message.success('仓库档案已保存')
        this.cancelEdit()
        this.loadData()
      }).finally(() => { this.saving = false })
    },
    // 暂时只保留一个仓库，先不开放启停
    // toggleStatus (record) {
    //   const enabled = record.status !== 'enabled'
    //   this.$confirm({
    //     title: enabled ? '启用仓库' : '停用仓库',
    //     content: enabled ? '启用后可用于新销售订单。' : '存在库存或未完成订单时将无法停用。',
    //     onOk: () => setWarehouseEnabled(record.id, enabled).then(() => this.loadData())
    //   })
    // }
  }
}
</script>

<style scoped>
.record-count{color:#8b96a8;font-size:12px;white-space:nowrap}.warehouse-grid{grid-template-columns:repeat(4,minmax(150px,1fr))}@media(max-width:1100px){.warehouse-grid{grid-template-columns:1fr 1fr}}@media(max-width:700px){.warehouse-grid{grid-template-columns:1fr}}
</style>
